import { render, staticRenderFns } from "./installList.vue?vue&type=template&id=a1af8bd8&"
import script from "./installList.vue?vue&type=script&lang=js&"
export * from "./installList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports